import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import styles from './Navbar.module.css';
import userLogo from "../../../images/user.png";
import useClickOutside from "../../../hooks/useClickOutside";

// Menú de usuario del navbar. Sin usuario muestra solo el ícono.
const UserMenu = ({ user, logout }) => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  const closeUserMenu = useCallback(() => setUserMenuOpen(false), []);
  useClickOutside(userMenuRef, closeUserMenu, userMenuOpen);

  useEffect(() => {
    if (!userMenuOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setUserMenuOpen(false);
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [userMenuOpen]);

  const handleLogout = () => {
    logout();
    window.location.href = "/";
  };

  if (!user) {
    return (
      <div className={styles.userMenu}>
        <img className={styles.logo} src={userLogo} alt="logo user" />
      </div>
    );
  }

  return (
    <div className={styles.userMenu} ref={userMenuRef}>
      <button
        type="button"
        className={styles.userMenuBtn}
        aria-haspopup="menu"
        aria-expanded={userMenuOpen}
        aria-label={user.nombre ? `Menú de usuario: ${user.nombre}` : "Menú de usuario"}
        title={user.nombre || "Menú de usuario"}
        onClick={() => setUserMenuOpen((open) => !open)}
      >
        <img className={styles.logo} src={userLogo} alt="" />
      </button>
      {userMenuOpen && (
        <ul className={styles.userMenuList} role="menu">
          <li role="none" className={styles.userMenuHeader}>
            <span className={styles.userMenuName}>{user.nombre}</span>
            {user.email && <span className={styles.userMenuEmail}>{user.email}</span>}
          </li>
          <li role="none">
            <Link className={styles.userMenuItem} role="menuitem" to="/perfil" onClick={closeUserMenu}>
              Perfil
            </Link>
          </li>
          <li role="none">
            <Link className={styles.userMenuItem} role="menuitem" to="/CambioContrasena" onClick={closeUserMenu}>
              Cambiar contraseña
            </Link>
          </li>
          <li role="none" className={styles.userMenuSeparator}>
            <button type="button" className={styles.userMenuItem} role="menuitem" onClick={handleLogout}>
              Cerrar sesión
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default UserMenu;
